import React, { useEffect, useState } from "react";
import { __t } from "../../../utils/translate";

const countries = [
    {
        code: "ortorex.com",
        title: __t("United States")
    },
    {
        code: "ortorex.ca",
        title: __t("Canada")
    },
    {
        code: "ortorex.ie",
        title: __t("Ireland")
    },
    {
        code: "ortorex.nz",
        title: __t("New Zealand")
    },
    {
        code: "ortorex.de",
        title: __t("Germany")
    },
    {
        code: "ortorex.es",
        title: __t("Spain")
    },
    {
        code: "ortorex.ch",
        title: __t("Switzerland")
    },
    {
        code: "ortorex.fr",
        title: __t("France")
    },
    {
        code: "ortorex.uk",
        title: __t("United Kingdom")
    },
    {
        code: "ortorex.au",
        title: __t("Australia")
    },
    {
        code: "ortorex.at",
        title: __t("Austria")
    },
    {
        code: "ortorex.pt",
        title: __t("Portugal")
    },
    {
        code: "ortorex.se",
        title: __t("Sweden")
    },
    {
        code: "ortorex.no",
        title: __t("Norway")
    },
    {
        code: "ortorex.fi",
        title: __t("Finland")
    },
    {
        code: "ortorex.dk",
        title: __t("Denmark")
    },
    {
        code: "ortorex.it",
        title: __t("Italy")
    },
    {
        code: "ortorex.nl",
        title: __t("Netherlands")
    },
    {
        code: "ortorex.be",
        title: __t("Belgium")
    },
    {
        code: "ortorex.cz",
        title: __t("Czech Republic")
    },
    {
        code: "ortorex.hu",
        title: __t("Hungary")
    },
    {
        code: "ortorex.ro",
        title: __t("Romania")
    },
    {
        code: "ortorex.gr",
        title: __t("Greece")
    },
    {
        code: "ortorex.ae",
        title: __t("United Arab Emirates")
    },
    {
        code: "ortorex.qa",
        title: __t("Qatar")
    },
    // {
    //     code: "ortorex.",
    //     title: __t("")
    // },
]

const generateCountryLink = (domain: string, currentPath: string) => {
    return `${process.env.GATSBY_HTTPS ? 'https' : 'http'}://${domain}${currentPath}`;
};

type FooterMenuType = {
    className?: string;
    title: string;
};

const OtherCountries: React.FC<FooterMenuType> = ({ className = "", title }) => {
    const [links, setLinks] = useState<string[] | null>(null);
    const [currentHref, setCurrentHref] = useState('');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const updatedLinks = countries.map(country => generateCountryLink(country.code, window.location.pathname));
            setLinks(updatedLinks);
            setCurrentHref(window.location.href);
        }
    }, []);

    if (!links) return;

    return (
        <div className={`${className} py-8 md:pt-0 text-center md:text-left`}>
            <p className="text-base-16 text-light-gray uppercase mb-[10px] font-bold">
                {title}
            </p>
            <div className={`flex flex-wrap w-fit justify-center md:justify-start`}>
                {countries.map((country, idx) => {
                    const active = links[idx] === currentHref ? '!font-bold' : '!font-light';
                    return (
                        <a
                            key={idx}
                            className={`${active} footer-link mr-3 mb-[6px] md:mb-0 text-small-14 md:text-base-16 text-footer-text-color`}
                            href={links.length > idx ? links[idx] : `https://${country.code}/`}
                        >
                            {country.title}
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default OtherCountries;